<template lang="pug">
  .say(:class='[isShowSay ? animateStyl.in : animateStyl.out, getPlatform]',
    v-show='isShowSay',
    @touchmove='handleDefaultPrevent')
    .say-wrap.pos-a
      closeCtrl(@on-close='close')

      scroll.say-body.pos-a(
        ref='scrollHook'
        :click='false',
        :data='getComments',
        :pullDownRefresh='pullDownRefresh',
        :pullUpLoad='pullUpLoad',
        :scrollbar='scrollBar',
        :mouseWheel='mouseWheel',
        @onScroll='handleScroll',
        @pullingUp='handlePullUp',
        @pullingDown='handlePullDown')
        .say-list(@click='clearReply')
          .item.flex(v-for='(item, gidx) in getComments', :key='gidx')
            .avatar.img-box
              img(:src='item.avatar', alt='头像')
            .content
              .name.omit {{ item.nickname }}
              .text {{ item.content }}
              .exact
                //- span
                //-   i.iconfont.icon-zan
                //- span
                //-   i.iconfont.icon-cai
                span {{ item.created | formatPassTime }}
                span.to-reply(@click.stop.prevent='handleReply(item.id, item.nickname)') 回复
              .more(v-if='item.total_replays', @click.prevent='showMore(item.id, gidx)')
                span(v-show='!item.showReply') 查看 {{ item.total_replays }} 条回复
                span(v-show='item.showReply') 隐藏评论
                span
                  i.iconfont.icon-down
              .reply(v-show='item.showReply && item.replyList.length')
                .item.flex(
                  v-for='(reply, cidx) in item.replyList',
                  :key='cidx')
                  .avatar.img-box
                    img(:src='reply.avatar')
                  .reply-info
                    .name.omit {{ reply.nickname }}
                    .text {{ reply.content }}
                    .exact
                      span {{ reply.created | formatPassTime }}
                //- a.more.load-more(v-if='item.replyList.length < item.total_replays')
                //-   span(@click.prevent='showMore(item.id, gidx)') 查看更多回复
                    //- .exact
                    //-   span
                    //-     i.iconfont.icon-zan
                    //-   span
                    //-     i.iconfont.icon-cai
                    //-   span(@click.stop.prevent='handleReply(reply.id, reply.nickname)') 回复
                    //- a.more(v-if='item.comment_replay_items.length', @click='showSubMore(gidx, cidx)')
                    //-   span 查看 {{ item.comment_replay_items.length }} 条回复
                    //-   span
                    //-     i.iconfont.icon-down
          .no-more.tac(v-if='!hasSayMore')
            p 没有更多了

      .say-foot.pos-a.flex
        span.label(@click='clearReply') {{ getCommentType }}
        .input-field
          input(
            type='text',
            v-model='message',
            placeholder='请输入内容',
            :max='10',
            @keyup.enter='submitComment',
            @focus='inputFocus',
            @blur='inputBlur',
            @input='inputChange')
          .icon.pos-a(v-show='clearable', @click='clearInput')
            i.iconfont.icon-close
        button.sbmt-btn(type='button',  @click='submitComment') 评论
</template>

<script>
import { isPC } from '@/utils'
import sayMixin from '@/mixins/say'
export default {
  mixins: [sayMixin],
  data() {
    return {
      scrollBar: {
        fade: false,
        interactive: true,
      },
      pullDownRefresh: {
        threshold: 50,
        stop: 20,
        txt: '刷新成功',
      },
      pullUpLoad: {
        threshold: 50,
        txt: '加载更多',
      },
      animateStyl: {
        in: 'animated bounceInUp',
        out: 'animated bounceOutUp',
      },
    }
  },
  created() {
    if (isPC()) {
      this.mouseWheel = true
      this.animateStyl = {
        in: 'animated bounceInRight',
        out: 'animated bounceOutRight',
      }
    } else {
      this.mouseWheel = false
    }
  },
  computed: {
    getCommentType() {
      return this.replyObj.name ? `回复 ${this.replyObj.name}` : `留言`
    },
    getPlatform() {
      return isPC() ? 'say-pc' : 'say-app'
    },
  },
  methods: {
    handleDefaultPrevent(e) {
      e.preventDefault()
    },
    inputFocus() {
      this.showClearable()
    },
    inputBlur() {
      window.scrollTo(0, 0)
    },
    inputChange(val) {
      this.showClearable()
    },
    showClearable() {
      this.clearable = this.message ? 1 : 0
    },
  },
}
</script>

<style lang="stylus">
@import '~assets/styles/mixins.styl'
@import '~assets/styles/colors.styl'
@import '~assets/styles/variables.styl'
$height = 75%
$padding-height = 25%
$input-height = 40px

.say-pc
  full-cover()
  .say-wrap
    right: 0
    width: 500px
    height: 100%

.say-app
  full-cover()
  .say-wrap
    full-cover()
    top: 20%
    .say-body
      overflow: hidden

.say
  z-index: $--zindex-high
  background-color: rgba($--color-black, .3)
  .say-wrap
    box-sizing: border-box
    background-color: $--color-white

    .say-body
      $avatar-max = 30px
      $avatar-min = 20px
      top: 20px
      bottom: $input-height + 20
      width: 100%
      .comments
        height: 100%
      .say-list
        padding: 0 10px 40px 10px
        .item
          padding: 6px 0
          .exact
            & > span
              padding-right: 5px
              color: $--color-gray-dark
            .to-reply
              color: $--color-blue
              cursor: pointer
          .more
            & > span
              color: $--color-gray-light
          .load-more
            padding-left: 50px
          .avatar
            flex: 0 0 $avatar-max
            width: $avatar-max
            height: $avatar-max
            padding: 0 10px
            overflow: hidden
            img
              width: 100%
              height: 100%
              border-radius: 50%
          .content
            flex: 1
            font-size: 14px
            .name
              color: $--font-color
            .text
              color: $--font-title-color
            .replay
              .reply-info
                flex: 1

    .say-foot
      bottom: 0
      left: 0
      right: 0
      height: 40px
      z-index: 10
      border-top: 1px solid #ddd
      font-size: 14px
      background-color: #f1f1f1
      z-index: $--zindex-high
      .label
        display: inline-block
        line-height: 35px
        padding: 0 5px
        color: $--color-gray-light
      .input-field
        position: relative
        flex: 1
        input
          width: 100%
          padding: 9px 40px 9px 5px
          font-size: 14px
          box-sizing: border-box
          border: none
          outline: none
        .icon
          right: 0
          top: 0
          width: 20px
          height: 100%
          line-height: 35px
          cursor: pointer

      .sbmt-btn
        font-size: 14px
        padding: 0 10px
        color: $--color-blue
        border: none
        background: transparent
      .el-input
        padding-right: 40px
        input
          padding: 0 30px
      .el-button
        position: absolute
        top: 0
        right: 25px
  .no-more
    font-size: 14px
    color: $--color-gray-light
</style>
